import React from 'react'
import './OfficeLocations.component.scss'

const offices = [
  {
    title: 'USABG Springboro, OH',
    address: ['15 South Main Street', 'Springboro, OH. 45066'],
    phone: '1 (937) 619-9939',
    tel: 'tel:19376199939',
  },
  {
    title: 'USABG Township, OH',
    address: ['9373 Cincinnati Columbus Rd.', 'West Chester Township, OH 45069'],
    phone: '1 (937) 880-1040',
    tel: 'tel:19378801040',
  },
  {
    title: 'USABG Headquarters',
    address: ['5141 Mariner Blvd.', 'Spring Hill, FL 34609'],
    phone: '1 (888) 826-1966',
    tel: 'tel:18888261966',
  },
  {
    title: 'USABG Brentwood, TN',
    address: ['116 Wilson Pike Cir', 'Suite 240 Brentwood TN 37027'],
    phone: '1 (615) 492-1292',
    tel: 'tel:16154921292',
  },
  {
    title: 'USABG Daytona Beach, FL',
    address: ['913 Big Tree Rd', 'Daytona Beach, FL 32119'],
    phone: '1 (386) 341-6791',
    tel: 'tel:13863416791',
  },
]

const OfficeLocations = () => {
  return (
    <section className='office-locations'>
      <div className='office-locations__grid'>
        {offices.map((office, index) => (
          <div className='office-locations__card' key={index}>
            <h3 className='office-locations__title'>
              <span>{office.title}</span>
            </h3>
            <p className='office-locations__address'>
              <span>
                {office.address[0]}
                <br />
                {office.address[1]}
                <br />
                Office:{' '}
              </span>
              <a href={office.tel} target='_blank' rel='noopener noreferrer' className='office-locations__phone'>
                {office.phone}
              </a>
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default OfficeLocations
